import cloneDeep from 'lodash/fp/cloneDeep'
import {
  START_EDITING_PROFILE_APPROVAL_AREAS_OF_SPECIALISATION
  , STOP_EDITING_PROFILE_APPROVAL_AREAS_OF_SPECIALISATION
  , CANCEL_EDITING_PROFILE_APPROVAL_AREAS_OF_SPECIALISATION
  , ADVISER_PROFILE_APPROVAL_AREAS_OF_SPECIALISATION_PREFERENCES_FETCHED_AREAS_OF_SPECIALISATION
  , ADVISER_PROFILE_APPROVAL_AREAS_OF_SPECIALISATION_PREFERENCES_AREAS_OF_SPECIALISATION_SELECTED_CHANGED
} from './adviserProfileAreasOfSpecialisationEditorActions'

import { listDifferenceComputer } from '../../../../../common/ReducerHelperFunctions/listDifferenceComputer'

import { events as containerEvents } from '../../AdviserProfileApprovalEditorContainer/adviserProfileApprovalEditorContainerActions'

import { validiateChecklistField } from '../../../../../common/forms/validationFunctions'

const initialState = {
  loadingAreasOfSpecialisation: false,
  editingAreasOfSpecialisation: false,
  areasOfSpecialisationBeforeEditing: [],
  allAreasOfSpecialisation: [],
  isInvalid: {
    formIsValid: true,
    areasOfSpecialisation: {
      isInvalid: false,
      message: null
    }
  },
  profileModifications: []
}

const minimumRequiredSelection = 1

export default function (state = initialState, action) {
  var newState = copyAreasOfSpecialisationPreferencesState(state)

  switch (action.type) {
    case containerEvents.fetch.fetched:
      newState.areasOfSpecialisation.profileModifications = findAreaOfSpecialisationModifications(newState.publishedProfile, newState.pendingApprovalProfile)
      return newState
    case START_EDITING_PROFILE_APPROVAL_AREAS_OF_SPECIALISATION:
      newState.areasOfSpecialisation.editingAreasOfSpecialisation = true
      newState.areasOfSpecialisationBeforeEditing = newState.pendingApprovalProfile.financialServicesOffered
      newState.areasOfSpecialisation.isInvalid.areasOfSpecialisation = validiateChecklistField(newState.pendingApprovalProfile.financialServicesOffered, minimumRequiredSelection)
      newState.areasOfSpecialisation.isInvalid.formIsValid = formIsValid(newState.areasOfSpecialisation.isInvalid)
      return newState
    case STOP_EDITING_PROFILE_APPROVAL_AREAS_OF_SPECIALISATION:
      newState.areasOfSpecialisation.editingAreasOfSpecialisation = false
      return newState
    case CANCEL_EDITING_PROFILE_APPROVAL_AREAS_OF_SPECIALISATION:
      newState.areasOfSpecialisation.editingAreasOfSpecialisation = false
      newState.pendingApprovalProfile.financialServicesOffered = cloneDeep(newState.areasOfSpecialisationBeforeEditing)
      newState.areasOfSpecialisationBeforeEditing = []
      newState.areasOfSpecialisation.profileModifications = findAreaOfSpecialisationModifications(newState.publishedProfile, newState.pendingApprovalProfile)
      return newState
    case ADVISER_PROFILE_APPROVAL_AREAS_OF_SPECIALISATION_PREFERENCES_FETCHED_AREAS_OF_SPECIALISATION:
      newState.areasOfSpecialisation.allAreasOfSpecialisation = action.payload
      return newState
    case ADVISER_PROFILE_APPROVAL_AREAS_OF_SPECIALISATION_PREFERENCES_AREAS_OF_SPECIALISATION_SELECTED_CHANGED:
     const selectedAreasOfSpecialisation = newState.pendingApprovalProfile.financialServicesOffered || []
      const exists = selectedAreasOfSpecialisation.some(
        area => area.financialServiceId === action.areaOfSpecialisation.financialServiceId
      )

      const updatedAreas = exists
        ? selectedAreasOfSpecialisation.filter(
          area => area.financialServiceId !== action.areaOfSpecialisation.financialServiceId
        )
        : [...selectedAreasOfSpecialisation, action.areaOfSpecialisation]

      newState.pendingApprovalProfile = {
        ...newState.pendingApprovalProfile,
        financialServicesOffered: updatedAreas
      }
      newState.areasOfSpecialisation.isInvalid.areasOfSpecialisation = validiateChecklistField(updatedAreas, minimumRequiredSelection)
      newState.areasOfSpecialisation.isInvalid.formIsValid = formIsValid(newState.areasOfSpecialisation.isInvalid)
      newState.areasOfSpecialisation.profileModifications = findAreaOfSpecialisationModifications(newState.publishedProfile, newState.pendingApprovalProfile)
      newState.edited = true
      return newState
    }
      return state
}

function copyAreasOfSpecialisationPreferencesState (state) {
  var newState = cloneDeep(state)
  newState.pendingApprovalProfile = cloneDeep(state.pendingApprovalProfile)
  if (state.pendingApprovalProfile) {
    newState.pendingApprovalProfile.financialServicesOffered = cloneDeep(state.pendingApprovalProfile.financialServicesOffered)
  }
  return newState
}

function formIsValid (isInvalid) {
  return !isInvalid.areasOfSpecialisation.isInvalid
}

function findAreaOfSpecialisationModifications (oldProfile, newProfile) {
  return listDifferenceComputer(oldProfile.financialServicesOffered, newProfile.financialServicesOffered, 'financialServiceId')
}
